import React, {Component} from "react";
import _ from 'lodash';
import Authentication from "../../authentication/Authentication";
import SignUpForm from "./SignUpForm";
import Login from "./Login";
import VerificationCodeForm from "./VerificationCodeForm";
import ForgottenPasswordForm from "./ForgottenPasswordForm";
import ForgottenPasswordConfirmation from "./ForgottenPasswordConfirmation";
import Validation from "../../validation/Validation";
import {Redirect} from "react-router-dom";
import './AuthForm.css';

export default class AuthForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showSignUp: false,
            showLogin: true,
            email: '',
            password: '',
            confirmPassword: '',
            validationErrors: [],
            verificationCode: '',
            successfulLogin: false,
            postVerification: false,
            resetPassword: false,
            error: '',
            showGenericSignupMessage: false,
            resetClickable: false
        };

        this.authentication = new Authentication();
        this.validation = new Validation();
    }

    showSignUp = () => {
        this.setState({
            showSignUp: true,
            showLogin: false,
            error: ''
        });
    };

    showLogin = () => {
        this.setState({
            showSignUp: false,
            showLogin: true,
            error: ''
        });
    };

    showVerificationInput = () => {
        this.setState({
            showGenericSignupMessage: true,
            showLogin: false,
            showSignUp: false,
            error: ''
        });
    };

    successfulLogin = () => {
        this.setState({
            successfulLogin: true
        });
    };

    postVerification = () => {
        this.basicLogin();
    };

    setForgottenPasswordError = (error) => {
        if (error.code === "UserNotFoundException") {
            this.setState({
                resetPassword: true,
                showForgottenPassword: false,
                showSignUp: false,
                showLogin: false,
                enterVerificationCode: false,
                error: ''
            });
        } else {
            this.setState({
                error: error.message
            });
        }
    };

    setNoUserError = (error) => {
        if (error.code === "UserNotFoundException") {
            this.setState({
                error: "Incorrect username or password."
            });
        } else {
            this.setState({
                error: error.message
            });
        }
    }

    setFormError = (error) => {
        this.setState({
            error: error.message
        });
    };

    handleChange = (event) => {
        const target = event.target;
        const field = target.name;
        const value = target.value;

        const errors = this.validation.runValidationRules(target, this.state.validationErrors);

        if (field === 'email'){
            const emailError = errors.email ? Object.values(errors.email).shift() : '';
            const emailMessageError = typeof emailError === 'string' ? emailError : ''
            this.setState({resetClickable: emailMessageError.length === 0})
        }

        this.setState({
            errors: errors
        });

        this.setState({
            [field]: value
        });
    };

    handleChangeWithoutValidation = (event) => {
        const target = event.target;
        const field = target.name;
        const value = target.value;

        this.setState({
            [field]: value
        });
    };

    setSignUpWithExistingEmailError = (error) => {
        if (error.code === "UsernameExistsException") {
            this.setState({
                showGenericSignupMessage: true,
                showLogin: false,
                showSignUp: false,
            });
        } else {
            this.setState({
                error: error.message,
                showGenericSignupMessage: true
            });
        }
    }

    signUp = (event) => {
        event.preventDefault();

        const formElements = this.validation.validateForm("signUpForm");
        let errors = {};
        formElements.forEach(element => {
            errors = this.validation.runValidationRules(element, errors);
        });

        if (!_.isEmpty(errors)) {
            this.setState({
                validationErrors: errors
            });
        } else {
            this.authentication.signUp(this.state.email, this.state.password, this.showVerificationInput, this.setSignUpWithExistingEmailError);
        }
    };

    login = (event) => {
        event.preventDefault();

        const formElements = this.validation.validateForm("loginForm");
        let errors = {};
        formElements.forEach(element => {
            errors = this.validation.runValidationRules(element, this.state.validationErrors);
        });

        if (!_.isEmpty(errors)) {
            this.setState({
                validationErrors: errors
            });
        } else {
            this.basicLogin();
        }
    };

    verify = (event) => {
        event.preventDefault();

        const code = this.state.verificationCode;
        const email = this.state.email;

        this.authentication.verify(email, code, this.postVerification, this.setFormError, this.showVerificationInput);
    };

    resetState = () => {
        this.setState({
            showSignUp: false,
            showLogin: true,
            showForgottenPassword: false,
            email: '',
            password: '',
            confirmPassword: '',
            validationErrors: [],
            enterVerificationCode: false,
            verificationCode: '',
            successfulLogin: false,
            postVerification: false,
            resetPassword: false,
            error: '',
            resetClickable: false
        });
    };

    setSuccessfulResend = () => {
        this.setFormError({'message': 'Verification code sent.'})
    };

    resendCode = () => {
        this.authentication.resendCode(this.state.email, this.setSuccessfulResend, this.setFormError);
    };

    forgottenPassword = (e) => {
        e.preventDefault();
        this.authentication.forgottenPassword(this.state.email, this.showResetPassword, this.setForgottenPasswordError);
    };

    showForgottenPassword = () => {
        this.setState({
            showForgottenPassword: true,
            showSignUp: false,
            showLogin: false,
            enterVerificationCode: false,
            error: ''
        })
    };

    showResetPassword = () => {
        this.setState({
            showForgottenPassword: false,
            showSignUp: false,
            showLogin: false,
            enterVerificationCode: false,
            resetPassword: true
        });
    };

    basicLogin = () => {
        this.authentication.authenticate(this.state.email, this.state.password, this.successfulLogin, this.setNoUserError, this.showVerificationInput);
    };

    resetPassword = (e) => {
        e.preventDefault();
        this.authentication.resetPassword(this.state.email, this.state.verificationCode, this.state.password, this.postVerification, this.setFormError);
    };

    render() {
        if (this.authentication.isLoggedIn() || this.state.postVerification) {
            return (<Redirect to={'/trypi'}/>)
        }
        if (this.state.showLogin) {
            return (
                <div className="auth-form-container" data-testid="loginForm.container">
                    <p className="login-sign-up"><span className={"selected-text"} data-testid="loginForm.container.text.login">Login</span> <span className={"not-selected-text"} data-testid="loginForm.container.button.signUp" onClick={this.showSignUp}>or sign up</span></p>
                    <Login email={this.state.email} password={this.state.password} handleChange={this.handleChange}
                           validationErrors={this.state.validationErrors} showForgottenPassword={this.showForgottenPassword}
                           showSignup={this.showSignUp} login={this.login} error={this.state.error}/>
                </div>
            )
        } else if (this.state.showSignUp) {
            return (
                <div className={"auth-form-container"} data-testid="signUpForm.container">
                    <p className={"login-sign-up"}><span className={"not-selected-text"} data-testid="signUpForm.container.button.login" onClick={this.showLogin}>Login</span><span className={"selected-text"} data-testid="signUpForm.container.text.signUp"> or sign up</span></p>
                    <SignUpForm email={this.state.email} password={this.state.password} handleChange={this.handleChange}
                                validationErrors={this.state.validationErrors} resetState={this.resetState}
                                signUp={this.signUp} error={this.state.error}/>
                </div>
            );
        } else if (this.state.showGenericSignupMessage) {
            return (
                <div className={"auth-form-container"} data-testid="signUpForm.container">
                    <div className={"form-instructions"} data-testid="signUpForm.container.text.instructions">
                        <p>An email has been sent to your email address.</p>
                        <p>Please follow the instructions in this email to continue the user registration process.</p>
                    </div>
                    <VerificationCodeForm verificationForm={this.state.verificationCode}
                                          handleChangeWithoutValidation={this.handleChangeWithoutValidation}
                                          error={this.state.error} resetState={this.state.resetState} verify={this.verify} resendCode={this.resendCode}/>
                </div>
            )
        } else if (this.state.showForgottenPassword) {
            return (
                <div className={"auth-form-container"} data-testid="forgottenPasswordForm.container">
                    <p className={"form-instructions"} data-testid="forgottenPasswordForm.container.text.instructions">Enter your email to reset your password.</p>
                    <ForgottenPasswordForm email={this.state.email} handleChange={this.handleChange}
                                           validationErrors={this.state.validationErrors}
                                           error={this.state.error}
                                           resetState={this.resetState} forgottenPassword={this.forgottenPassword}
                                           resetClickable={this.state.resetClickable}
                    />
                </div>
            );
        } else if (this.state.resetPassword) {
            return (
                <div className={"auth-form-container"} data-testid="resetPasswordForm.container">
                    <p className={"form-instructions"} data-testid="resetPasswordForm.container.text.instructions">If the username exists on this application then a password reset email will be sent to the corresponding email address</p>
                    <ForgottenPasswordConfirmation verificationCode={this.state.verificationCode}
                                                   handleChange={this.handleChange}
                                                   validationErrors={this.state.validationErrors}
                                                   password={this.state.password}
                                                   confirmPassword={this.state.confirmPassword} error={this.state.error}
                                                   resetState={this.state.resetState} resetPassword={this.resetPassword}/>
                </div>
            );
        } else {
            return (
                <p>Error. Check state.</p>
            );
        }

    }
}